module.exports = __webpack_public_path__ + "static/img/B.440d486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/B.png
// module id = 3SLB
// module chunks = 0